























import { Suggestion } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    })
  }
})
export default class Suggestions extends Vue {
  @Prop({ required: true })
  suggestions: Suggestion[];

  @Prop({ required: true })
  highlightedEmpathizeItem: any;

  @Prop({ default: false })
  showWhenEmpty: boolean;

  @Prop({ default: EVENTS.SuggestionSelected })
  event: string;
}
